import { useEffect } from "react";
import { createMicroConversionTrackingUtils } from "..";
import useProfiler from "../../../hooks/useProfiler";
import { useSelector } from "react-redux";
import { getExtraProducts } from "../../../ancillaries/store/extraProducts/selectors";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_condensed_extras_fd_ddot",
  stages: {
    fd: 1, // fallback stage
    main: 2, // FD where users see extras
    direct: 3,
    meta: 4,
    oneWay: 5,
    roundTrip: 6,
    solo: 7,
    nonsolo: 8
  },
  defaultStage: 1,
  mainStage: 2,
  goals: {},
  goalsWithValue: []
});

const useTrackStages = (isInViewport: boolean) => {
  const stages = utils.stages;
  const { isDirect, isOneWay, isRountrip, isSolo } = useProfiler();

  const extraProducts = useSelector(getExtraProducts);

  useEffect(() => {
    if (!extraProducts || !isInViewport) {
      return;
    }

    stages.main();
    isDirect() ? stages.direct() : stages.meta();
    isOneWay() && stages.oneWay();
    isRountrip() && stages.roundTrip();
    isSolo() ? stages.solo() : stages.nonsolo();
  }, [isDirect, isOneWay, isRountrip, isSolo, stages, isInViewport, extraProducts]);
};
export default { ...utils, useTrackStages };
